import { Loader } from "@circle-react-uikit/Loader";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useEffect } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import Features from "../Features";
import { PlanSelector } from "../PlanSelector";
import { TopSection } from "../TopSection";
import { MobileCheckoutOverlay } from "./MobileCheckoutOverlay";
import { PlanSummary } from "./PlanSummary";
import { SocialProof } from "./SocialProof";

export const PlansManagement = () => {
  const { isLoading: isCurrentCommunityLoading } = usePunditUserContext();
  const { isCurrentPlanLoading } = usePlans();
  const { isCommunityOnTrial } = usePlanStatus();
  const { isCompactLayout, isDesktopLayout, isMobileLayout } =
    usePlanPageVariant();
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_page.visited", {});
  }, [trackEvent]);

  // TODO: Growth to review mobile support access after Help Widget removal.
  if (isCurrentPlanLoading || isCurrentCommunityLoading) {
    return <Loader variant="fullscreen" />;
  }

  return (
    <>
      <div
        className={classNames("flex flex-col gap-6", {
          "pt-4 lg:pt-0": isCommunityOnTrial,
          "pb-32": isMobileLayout,
        })}
      >
        <TopSection />
        <div className="flex flex-col gap-10 md:gap-20">
          <div className="flex md:gap-6">
            <div
              className={classNames(
                "flex flex-col gap-10",
                isCompactLayout ? "w-[550px]" : "w-[681px]",
                { "w-full": isMobileLayout },
              )}
            >
              <PlanSelector />
            </div>
            <div>{isDesktopLayout && <PlanSummary />}</div>
          </div>
          <SocialProof />
          <Features />
        </div>
      </div>
      <MobileCheckoutOverlay />
    </>
  );
};
